import { LoadingButton } from "@mui/lab";
import classNames from "classnames";

import { buttonIcons } from "../images";
import "./button.scss";

function Button({ label, variant, className, ...props }) {
  let classes = "";

  if (props.icon) {
    classes = classNames("button-with-icon", "button-wrapper", className);
    if (props.iconPosition === "start")
      props.startIcon = buttonIcons[props.icon];
    else props.endIcon = buttonIcons[props.icon];
  } else {
    classes = classNames("button-wrapper", className);
  }

  return (
    <LoadingButton
      variant={variant}
      className={classes}
      color={props.color}
      {...props}
    >
      {" "}
      <div className={props.textClass || ""}>{label}</div>{" "}
    </LoadingButton>
  );
}

export default Button;
